export default {
  // 通用
  '首頁': 'Home',
  '網站導覽': 'Site Map',
  ':::': ':::',
  
  // 無障礙相關
  '跳到中間主要內容區': 'Skip to main content',
  '上方區塊': 'Top section',
  '頁尾網頁資訊': 'Footer information',
  
  // 字級設定
  '字級': 'Font Size',
  '大': 'L',
  '中': 'M',
  '小': 'S',
  
  // 語言選擇
  '語言選擇': 'Language',
  '繁體中文': '繁體中文',
  'ENGLISH': 'ENGLISH',
  '日本語': '日本語',
  
  // 社交媒體
  'FB': 'FB',
  'IG': 'IG',
  'YOUTUBE': 'YOUTUBE',
  '另開新視窗': 'Opens in new window',
  '（另開新視窗）': ' (Opens in new window)',
  
  // 頁尾
  'TOP': 'TOP',
  'CopyRight©2026': 'CopyRight©2026',
  
  // 導航
  'Toggle navigation': 'Toggle navigation',
  
  // Home 頁面
  '跳到中央內容區塊': 'Skip to main content',
  '特展活動專區': 'Special Exhibition',
  '最新消息': 'Latest News',
  'READ MORE': 'READ MORE',
  '更多最新消息（另開新視窗）': 'More News (Opens in new window)',
  '活動行事曆': 'Event Calendar',
  '休館': 'Closed',
  '活動名稱': 'Event Name',
  '活動日期': 'Event Date',
  '活動地點': 'Event Location',
  '未指定地點': 'Location TBD',
  ' 圖片': ' Image',
  
  // Lesson Plans
  '教案專區': 'Lesson Plans',
  '登入帳號：': 'Login Account:',
  '剩餘可登入次數：': 'Remaining Logins:',
  '剩餘時間：': 'Time Remaining:',
  '登出': 'Logout',
  '載入中...': 'Loading...',
  '教案檔案列表': 'Lesson Plan Files',
  '#': '#',
  '檔案名稱': 'File Name',
  '副檔名': 'Extension',
  '檔案大小': 'File Size',
  '操作': 'Action',
  '下載': 'Download',
  '下載檔案': 'Download File',
  '目前沒有可下載的檔案': 'No files available for download',
  '登入時間已到，請重新登入': 'Session expired, please login again',
  '無法載入檔案列表': 'Unable to load file list',
  '載入檔案失敗，請稍後再試': 'Failed to load files, please try again later',
  '下載失敗': 'Download failed',
  '下載檔案失敗，請稍後再試': 'Failed to download file, please try again later',
  
  // Lesson Plans Login
  '登入': 'Login',
  '電子郵件': 'Email',
  '請輸入電子郵件': 'Please enter email',
  '密碼': 'Password',
  '請輸入密碼': 'Please enter password',
  '隱藏密碼': 'Hide password',
  '顯示密碼': 'Show password',
  '登入中...': 'Logging in...',
  '請輸入電子郵件和密碼': 'Please enter email and password',
  '請輸入有效的電子郵件格式': 'Please enter a valid email format',
  '登入失敗，請檢查您的電子郵件和密碼': 'Login failed, please check your email and password',
  '登入失敗，請稍後再試': 'Login failed, please try again later',
  
  // Post Page
  '檔案下載': 'File Download',
  '（必填）': ' (Required)',
  '此表單已達填寫上限，無法繼續填寫。': 'This form has reached its submission limit and cannot accept more entries.',
  '請輸入其他內容': 'Please enter other content',
  '未選擇': 'Not selected',
  '其他': 'Other',
  '檔案大小限制：': 'File size limit: ',
  'MB': 'MB',
  '允許類型：': 'Allowed types: ',
  '最小值：': 'Minimum: ',
  '最大值：': 'Maximum: ',
  '送出中...': 'Submitting...',
  '送出': 'Submit',
  '分享': 'Share',
  '分享至X（另開新視窗）': 'Share to X (Opens in new window)',
  '分享至FB（另開新視窗）': 'Share to FB (Opens in new window)',
  '驗證失敗': 'Validation Failed',
  '請檢查表單內容': 'Please check the form content',
  '確定': 'OK',
  '成功！': 'Success!',
  '表單已成功送出。您的資料已送出，請等候審核通知。': 'Form submitted successfully. Your data has been submitted, please wait for approval notification.',
  '表單已成功送出，感謝您的填寫。': 'Form submitted successfully. Thank you for your submission.',
  '錯誤': 'Error',
  '送出失敗，請稍後再試': 'Submission failed, please try again later',
  '連結已複製到剪貼簿': 'Link copied to clipboard',
  '複製失敗，請手動複製連結': 'Copy failed, please copy the link manually',
  '此欄位為必填': 'This field is required',
  '請輸入有效的電子郵件地址': 'Please enter a valid email address',
  '請輸入有效的網址': 'Please enter a valid URL',
  '輸入格式不正確': 'Input format is incorrect',
  '請輸入有效的數字': 'Please enter a valid number',
  '數字不可小於': 'Number cannot be less than',
  '數字不可大於': 'Number cannot be greater than',
  '檔案大小不可超過': 'File size cannot exceed',
  '僅允許上傳': 'Only',
  '格式的檔案': 'file formats are allowed',
  '檔案處理失敗，請重試': 'File processing failed, please try again',
  '附件': 'Attachment',
  
  // Reservation
  '參觀預約': 'Reservation',
  '團體預約': 'Group Reservation',
  '導覽預約': 'Guided Tour Reservation',
  '預約紀錄查詢': 'Reservation Inquiry',
  '【導覽解說預約須知】': '【Guided Tour Reservation Notice】',
  '隆田文化資產教育園區為全國第一座文化資產為主題之教育園區，並以「推廣臺南文化資產」、「文化資產教育資源整合」與「臺南文化資產國際交流」三大願景持續推進，提供導覽解說服務': 'Longtian Cultural Heritage Education Park is the nation\'s first education park themed around cultural heritage, advancing three major visions: "Promoting Tainan Cultural Heritage," "Integrating Cultural Heritage Education Resources," and "Tainan Cultural Heritage International Exchange," providing guided tour services.',
  '辦理【團體參觀預約】者（無導覽需求），請點選【團體預約】按鈕進入申請': 'For 【Group Visit Reservations】 (without guided tour), please click the 【Group Reservation】 button to apply.',
  '辦理【導覽解說預約】者，請點選【導覽預約】按鈕進入申請': 'For 【Guided Tour Reservations】, please click the 【Guided Tour Reservation】 button to apply.',
  '整日不開放': 'Closed all day',
  '已截止報名': 'Registration closed',
  '本日報名已額滿': 'Fully booked for this day',
  '有限制人數': 'Limited capacity',
  '無限制人數': 'Unlimited capacity',
  
  // Reservation Form
  '您所預約的日期為：': 'Your reservation date: ',
  '年': '/',
  '月': '/',
  '日': '',
  '預約時間': 'Reservation Time',
  '申請單位': 'Organization Name',
  '請輸入申請單位': 'Please enter organization name',
  '單位類型': 'Organization Type',
  '學校機關': 'School/Institution',
  '旅行業者': 'Travel Agency',
  '媒體記者': 'Media/Press',
  '私人企業': 'Private Company',
  '公務機關': 'Government Agency',
  '請輸入其他類型': 'Please specify other type',
  '貴團年齡層分布(以最大宗為主)': 'Age Group (majority)',
  '幼稚園': 'Kindergarten',
  '國小': 'Elementary School',
  '國中': 'Junior High School',
  '高中': 'Senior High School',
  '大學(含研究所)': 'University (including Graduate School)',
  '社會人士': 'General Public',
  '樂齡長者(65歲以上)': 'Seniors (65+)',
  '團體代表姓名': 'Group Representative Name',
  '請輸入參觀日聯絡人或導遊／領隊姓名': 'Please enter contact person or tour guide/leader name',
  '團體代表手機': 'Group Representative Phone',
  '請輸入參觀日聯絡人或導遊／領隊電話': 'Please enter contact person or tour guide/leader phone',
  '參觀人數': 'Number of Visitors',
  '(長者及6歲以下學童皆須計算人數在內)': '(Seniors and children under 6 must be included in the count)',
  '申請人姓名': 'Applicant Name',
  '請輸入姓名': 'Please enter name',
  '申請人身分證字號': 'Applicant ID Number',
  '請輸入身分證字號': 'Please enter ID number',
  '申請人手機': 'Applicant Phone',
  '請輸入手機': 'Please enter phone number',
  '申請人電子信箱': 'Applicant Email',
  '請輸入電子信箱': 'Please enter email',
  '預約備註': 'Remarks',
  '請輸入預約備註': 'Please enter remarks',
  '※ 若無法順利媒合導覽老師，將以電子信件或電話通知，故請確認聯繫資料填寫正確': '※ If a tour guide cannot be arranged, you will be notified by email or phone. Please ensure your contact information is correct.',
  '※ 參觀當天請出示名冊並預先確認符合半票或免費入場資格者人數': '※ Please present the visitor list on the day of visit and confirm the number of visitors eligible for half-price or free admission.',
  '我已經詳細閱讀並同意': 'I have read and agree to the',
  '使用規範': 'Terms of Use',
  '使用規範（另開新視窗）': 'Terms of Use (Opens in new window)',
  '重選日期': 'Reselect Date',
  '確認送出': 'Confirm Submit',
  
  // Reservation Form Validation
  '請選擇預約時間': 'Please select reservation time',
  '請選擇單位類型': 'Please select organization type',
  '請選擇年齡層': 'Please select age group',
  '請輸入團體代表姓名': 'Please enter group representative name',
  '請輸入團體代表手機': 'Please enter group representative phone',
  '請輸入有效的手機號碼（格式：09XXXXXXXX）': 'Please enter a valid phone number (Format: 09XXXXXXXX)',
  '參觀人數須介於': 'Number of visitors must be between',
  '人': 'person(s)',
  '請輸入有效的台灣身分證字號': 'Please enter a valid Taiwan ID number',
  '請輸入有效的電子信箱': 'Please enter a valid email address',
  '請閱讀並同意使用規範後再送出': 'Please read and agree to the terms of use before submitting',
  '請先選擇日期': 'Please select a date first',
  '請先選擇報名類型': 'Please select registration type first',
  '載入時段資訊失敗，請稍後再試': 'Failed to load time slots, please try again later',
  '報名成功！待管理員審核後將以電子郵件通知您': 'Registration successful! You will be notified by email after administrator approval.',
  '報名失敗，請稍後再試': 'Registration failed, please try again later',
  '提交時發生錯誤，請稍後再試': 'An error occurred during submission, please try again later',
  
  // Reservation Search
  '查詢中...': 'Searching...',
  '送出查詢': 'Submit Query',
  '查詢結果': 'Search Results',
  '共': 'Total: ',
  '筆': '',
  '查無符合的預約記錄': 'No matching reservation records found',
  '報名編號': 'Registration No.',
  '報名時間': 'Registration Time',
  '預約日期': 'Reservation Date',
  '預約時段': 'Time Slot',
  '報名類型': 'Registration Type',
  '審核狀態': 'Review Status',
  '待審核': 'Pending',
  '已通過': 'Approved',
  '未通過': 'Rejected',
  '未知': 'Unknown',
  '年齡層': 'Age Group',
 '無限制': 'Unlimited',
  '備註': 'Remarks',
  '審核時間': 'Review Time',
  '審核說明': 'Review Notes',
  '請輸入申請人電子信箱': 'Please enter applicant\'s email',
  '請輸入申請人身分證字號': 'Please enter applicant\'s ID number',
  '查詢時發生錯誤，請稍後再試': 'An error occurred during search, please try again later',
  '申請人信箱': 'Applicant Email',
  
  // Staff/Volunteer Login
  '員/志工登入': 'Staff/Volunteer Login',
  '登入': 'Login',
  '電子郵件': 'Email',
  '請輸入電子郵件': 'Please enter email',
  '密碼': 'Password',
  '請輸入密碼': 'Please enter password',
  '隱藏密碼': 'Hide password',
  '顯示密碼': 'Show password',
  '登入中...': 'Logging in...',
  '請輸入電子郵件和密碼': 'Please enter email and password',
  '請輸入有效的電子郵件格式': 'Please enter a valid email format',
  '登入失敗，請檢查您的電子郵件和密碼': 'Login failed, please check your email and password',
  '登入失敗，請稍後再試': 'Login failed, please try again later',
  
  // Site Map
  '網站導覽': 'Site Map',
  '網站的主要樣版內容分為三個大區塊：': 'The main structure of the website is divided into three major sections:',
  '(1)上方區塊 (2)中央內容區塊 (3)頁尾網頁資訊': '(1) Top Section (2) Central Content Section (3) Footer Information',
  '本網站的導盲磚﹝Accesskey,也稱為快速鍵﹞設定如下：': 'The access keys (also known as keyboard shortcuts) on this website are set as follows:',
  'Alt +U：移至網頁最上方之項目位置。': 'Alt +U: Jump to the top of the page.',
  'Alt +C：主要內容區，此區塊呈現網頁主要內容資訊。': 'Alt +C: Main content area, this section displays the main content information.',
  'Alt +B：下方頁尾網頁資訊。': 'Alt +B: Footer information at the bottom of the page.',
  
  // Hours & Admission
  '時間票價': 'Hours & Admission',
  '營業時間': 'Operating Hours',
  '星期': 'Day',
  '開館時間': 'Opening Hours',
  '星期一': 'Monday',
  '星期二': 'Tuesday',
  '星期三': 'Wednesday',
  '星期四': 'Thursday',
  '星期五': 'Friday',
  '星期六': 'Saturday',
  '星期日': 'Sunday',
  '09:00 – 17:00': '09:00 – 17:00',
  '10:00 – 17:00': '10:00 – 17:00',
  '休館': 'Closed',
  '最後售票時間及入園時間：16:30': 'Last admission time: 16:30',
  '休園日：每週三、小年夜、除夕': 'Closed: Every Wednesday, Lunar New Year\'s Eve (two days)',
  '※營運調整公告：自2026年1月1日起，隆田文化資產教育園區每週固定休園日，調整為「每週三」': '※Operation Notice: Starting from January 1, 2026, the Longtian Cultural Heritage Education Park will be closed every Wednesday.',
  '票價資訊': 'Admission Fees',
  '票種': 'Ticket Type',
  '票價': 'Price',
  '適用對象': 'Eligible Visitors',
  '全票': 'Full Ticket',
  '優惠票': 'Discounted Ticket',
  '半票': 'Half Ticket',
  '免費': 'Free',
  '一般遊客': 'General visitors',
  '持有學生證在學學生。': 'Students with valid student ID.',
  '20人以上團體之成員。': 'Members of groups of 20 or more.',
  '65歲以上長者。': 'Seniors aged 65 and above.',
  '6歲以上未滿12歲之兒童。': 'Children aged 6 to under 12.',
  '持有設籍於本市官田區之身分證明文件。': 'Residents of Guantian District with valid ID.',
  '未滿六歲之兒童。': 'Children under 6 years old.',
  '持有縣市政府依志願服務法之志願服務榮譽卡。': 'Holders of volunteer service honor cards.',
  '持有交通部觀光局核發之導遊人員執業證。': 'Licensed tour guides with valid credentials.',
  '持有身心障礙證明，其本人與隨同1人。': 'Persons with disabilities and one accompanying person.',
  '※凡購買優惠票、半票及免費票條件者，敬請出示相關證件，未攜帶者一律依全票計。': '※Visitors qualifying for discounted, half-price, or free tickets must present valid documents. Full price applies otherwise.',
  '※為鼓勵乘坐大眾交通運輸工具，如於園區服務台出示 T-Pass 或當日臺鐵隆田站下車之乘車證明或車票，即可享門票優惠價（70元）購票入園！': '※To encourage public transportation use, visitors showing T-Pass or same-day TRA Longtian Station ticket at the service counter can purchase a discounted ticket (NT$70)!',
  
  // Scheduling
  '排班列表': 'Schedule List',
  '員工': 'Staff',
  '志工': 'Volunteer',
  '員/志工排班': 'Staff/Volunteer Scheduling',
  '今日無勤務': 'No duty today',
  '員工公告': 'Staff Announcements',
  '志工公告': 'Volunteer Announcements',
  '排班期間': 'Schedule Period',
  '未開放排班': 'Not Open',
  '排班中': 'Open for Scheduling',
  '排班已截止': 'Closed',
  '開放排班時間': 'Scheduling Period',
  '已送出': 'Submitted',
  '暫存中': 'Draft',
  '未送出': 'Not Submitted',
  '預計時數': 'Expected Hours',
  '小時': 'hours',
  '實際時數': 'Actual Hours',
  '開始排班': 'Start Scheduling',
  '檢視排班': 'View Schedule',
  '尚未開放': 'Not Available',
  '目前沒有可排班的項目': 'No schedules available',
  '載入排班列表失敗': 'Failed to load schedule list',
  '載入排班列表失敗，請稍後再試': 'Failed to load schedule list, please try again later',
  
  // Check-in
  '上午打卡': 'Morning Check-in',
  '上午打卡(下班)': 'Morning Check-out',
  '上午打卡(完成)': 'Morning Complete',
  '下午打卡': 'Afternoon Check-in',
  '下午打卡(下班)': 'Afternoon Check-out',
  '下午打卡(完成)': 'Afternoon Complete',
  '已超過打卡時間': 'Time Exceeded',
  '上午打卡時間已過': 'Morning check-in time has passed',
  '未達可打卡時間': 'Not Yet Time',
  '下午打卡時間尚未到': 'Afternoon check-in time not yet reached',
  '下午打卡時間已過': 'Afternoon check-in time has passed',
  '打卡成功': 'Check-in Successful',
  '打卡失敗': 'Check-in Failed',
  '打卡失敗，請稍後再試': 'Check-in failed, please try again later',
  '確認下班': 'Confirm Check-out',
  '確定要下班打卡嗎？': 'Are you sure you want to check out?',
  '系統將計算您的工作時數': 'The system will calculate your working hours',
  '已執勤：': 'Worked: ',
  '分鐘': 'minutes',
  '下班打卡成功': 'Check-out Successful',
  
  // Staff Scheduling
  '員工排班表': 'Staff Schedule',
  '剩餘需排休假日：': 'Remaining Rest Days: ',
  '剩餘需排例假日：': 'Remaining Regular Days Off: ',
  '可上班日': 'Working Day',
  '休息日(可加班)': 'Rest Day (overtime allowed)',
  '例假日(不可加班)': 'Regular Day Off (no overtime)',
  '員工姓名': 'Staff Name',
  '注意事項': 'Notes',
  '國定假日，不可同時休假。': 'Cannot all take leave on national holidays.',
  '*如遇天然災害，依本市公佈放假標準為原則。': '*In case of natural disasters, follow the city\'s announced holiday standards.',
  '暫存': 'Save Draft',
  '返回列表': 'Back to List',
  '無效的排班 ID': 'Invalid Schedule ID',
  '載入排班資料失敗，請稍後再試': 'Failed to load schedule data, please try again later',
  '暫存成功': 'Draft Saved Successfully',
  '暫存失敗': 'Draft Save Failed',
  '休息日超過限制': 'Rest Days Exceeded',
  '休息日不足': 'Insufficient Rest Days',
  '例假日超過限制': 'Regular Days Off Exceeded',
  '例假日不足': 'Insufficient Regular Days Off',
  '確定要送出排班嗎？送出後將無法修改': 'Are you sure to submit the schedule? You cannot modify it after submission.',
  '取消': 'Cancel',
  '儲存失敗': 'Save Failed',
  '儲存排班資料失敗': 'Failed to save schedule data',
  '送出成功': 'Submitted Successfully',
  '您的排班已成功送出': 'Your schedule has been submitted successfully',
  '已達上限': 'Limit Reached',
  
  // Manage Staff Schedule
  '管理員工班表': 'Manage Staff Schedule',
  '管理者模式': 'Manager Mode',
  '管理者模式：可不受時間限制調整所有員工的排班': 'Manager Mode: Adjust all staff schedules without time restrictions',
  '儲存': 'Save',
  '確認儲存': 'Confirm Save',
  '確定要儲存所有員工的排班嗎？': 'Are you sure to save all staff schedules?',
  '確定儲存': 'Confirm Save',
  '儲存成功': 'Save Successful',
  '所有員工的排班已成功儲存': 'All staff schedules have been saved successfully',
  '無效的存取方式': 'Invalid Access Method',
  
  // Volunteer Application
  '志工申請': 'Volunteer Application',
  '志工申請表': 'Volunteer Application Form',
  '基本資訊': 'Basic Information',
  '電子信箱': 'Email',
  '請輸入電子信箱': 'Please enter email',
  '出生年月日': 'Date of Birth',
  '性別': 'Gender',
  '男': 'Male',
  '女': 'Female',
  '身份證字號': 'ID Number',
  '請輸入身份證字號': 'Please enter ID number',
  '照片': 'Photo',
  '選擇照片': 'Select Photo',
  '已選擇：': 'Selected: ',
  '支援格式: JPG, PNG / 檔案大小上限: 5MB': 'Supported formats: JPG, PNG / Max file size: 5MB',
  '學校': 'School',
  '請輸入學校名稱': 'Please enter school name',
  '系所': 'Department',
  '請輸入系所名稱': 'Please enter department name',
  '肄業/畢業': 'Study Status',
  '請選擇': 'Please select',
  '肄業': 'Enrolled',
  '畢業': 'Graduated',
  '婚姻狀況': 'Marital Status',
  '已婚': 'Married',
  '未婚': 'Single',
  '戶籍地址': 'Registered Address',
  '請輸入戶籍地址': 'Please enter registered address',
  '通訊地址': 'Mailing Address',
  '同戶籍地址': 'Same as registered address',
  '請輸入通訊地址': 'Please enter mailing address',
  '聯絡方式': 'Contact Information',
  '住家電話': 'Home Phone',
  '請輸入住家電話': 'Please enter home phone',
  '辦公電話': 'Office Phone',
  '請輸入辦公電話': 'Please enter office phone',
  '手機': 'Mobile',
  '請輸入手機號碼': 'Please enter mobile number',
  '※ 住家電話、辦公電話、手機三者至少需填寫一個': '※ At least one of home phone, office phone, or mobile is required',
  '就業/就學狀況': 'Employment/Study Status',
  '就業/就學狀態': 'Employment/Study Status',
  '就業中': 'Employed',
  '就學中': 'Studying',
  '退休': 'Retired',
  '就業單位': 'Employer',
  '請輸入就業單位': 'Please enter employer',
  '就讀學校': 'Current School',
  '請輸入就讀學校': 'Please enter current school',
  '其他狀態說明': 'Other Status Description',
  '請說明其他狀態': 'Please describe other status',
  '志工經驗': 'Volunteer Experience',
  '過去志工經驗': 'Past Volunteer Experience',
  '請描述過去的志工經驗': 'Please describe past volunteer experience',
  '目前志工經驗': 'Current Volunteer Experience',
  '請描述目前的志工經驗': 'Please describe current volunteer experience',
  '志願服務手冊': 'Volunteer Service Book',
  '有': 'Yes',
  '無': 'No',
  '專長與興趣': 'Skills and Interests',
  '專長': 'Skills',
  '導覽解說': 'Tour Guide',
  '藝術文學': 'Arts & Literature',
  '歷史人文': 'History & Humanities',
  '水電木工': 'Plumbing & Carpentry',
  '動物生態': 'Animal Ecology',
  '植物生態': 'Plant Ecology',
  '電腦美工': 'Computer Graphics',
  '攝影繪圖': 'Photography & Drawing',
  '電腦文書': 'Computer Office',
  '護理急救': 'Nursing & First Aid',
  '請說明其他專長': 'Please specify other skills',
  '興趣': 'Interests',
  '請描述您的興趣': 'Please describe your interests',
  '語言能力': 'Language Skills',
  '華語': 'Mandarin',
  '英語': 'English',
  '臺語': 'Taiwanese',
  '日語': 'Japanese',
  '精通': 'Fluent',
  '中等': 'Intermediate',
  '略懂': 'Basic',
  '不會': 'None',
  '其他語言': 'Other Languages',
  '有其他語言能力': 'Have other language skills',
  '語言名稱': 'Language Name',
  '請選擇程度': 'Please select proficiency',
  '申請動機': 'Motivation',
  '回饋社會，服務他人': 'Give back to society, serve others',
  '吸收藝文新知': 'Learn arts and culture',
  '精神生活樂趣': 'Spiritual life enjoyment',
  '交新朋友': 'Make new friends',
  '打發空閒時間': 'Fill leisure time',
  '磨練自己': 'Self-improvement',
  '請說明其他動機': 'Please specify other motivation',
  '健康狀況': 'Health Status',
  '特殊疾病': 'Special Medical Conditions',
  '請說明疾病狀況': 'Please describe medical conditions',
  '可服勤時段': 'Available Time Slots',
  '星期/時間': 'Day/Time',
  '09時-12時': '09:00-12:00',
  '13時-16時': '13:00-16:00',
  '休館日': 'Closed',
  '請依照優先順序勾選可服勤時段，系統會自動標注順序號碼': 'Select available time slots by priority, the system will automatically number them',
  '其他資訊': 'Other Information',
  '自我介紹': 'Self Introduction',
  '請簡單介紹您自己': 'Please introduce yourself briefly',
  '我已經詳細閱讀個人資料使用同意書並同意相關規範': 'I have read and agree to the personal data usage consent form',
  '下載個人資料使用同意書': 'Download Personal Data Usage Consent Form',
  '返回首頁': 'Back to Home',
  '確認送出': 'Confirm Submit',
  '送出中...': 'Submitting...',
  '照片檔案大小不得超過 5MB': 'Photo file size must not exceed 5MB',
  '請選擇有效的圖片檔案 (JPG, PNG, GIF)': 'Please select a valid image file (JPG, PNG, GIF)',
  '請輸入有效的台灣身分證字號': 'Please enter a valid Taiwan ID number',
  '住家電話、辦公電話、手機三者至少需填寫一個': 'At least one of home phone, office phone, or mobile is required',
  '請輸入有效的手機號碼（格式：09XXXXXXXX）': 'Please enter a valid mobile number (Format: 09XXXXXXXX)',
  '請選擇就業/就學狀態': 'Please select employment/study status',
  '請選擇是否有志願服務手冊': 'Please select whether you have a volunteer service book',
  '請選擇華語能力': 'Please select Mandarin proficiency',
  '請選擇英語能力': 'Please select English proficiency',
  '請選擇臺語能力': 'Please select Taiwanese proficiency',
  '請選擇日語能力': 'Please select Japanese proficiency',
  '請至少選擇一個可服勤時段': 'Please select at least one available time slot',
  '請填寫自我介紹': 'Please fill in self introduction',
  '請閱讀並同意相關規範後再送出': 'Please read and agree to the terms before submitting',
  '申請成功！我們將於審核後與您聯繫': 'Application successful! We will contact you after review',
  '申請失敗，請稍後再試': 'Application failed, please try again later',
  '提交時發生錯誤，請稍後再試': 'An error occurred during submission, please try again later',
  
  // Volunteer Scheduling
  '志工排班表': 'Volunteer Schedule',
  '上午場': 'Morning Shift',
  '下午場': 'Afternoon Shift',
  '全日': 'Full Day',
  '星期四至星期二上午9時至12時及下午1時至4時，採兩班制。': 'Thursday to Tuesday: 9:00-12:00 AM and 1:00-4:00 PM, two shifts per day.',
  '*如遇天然災害，依本市公佈放假標準為原則，不另行通知。': '*In case of natural disasters, follow the city\'s announced holiday standards, no separate notice.',
  '逾時未打卡': 'Overdue Check-in',
  '打卡: ': 'Check-in: ',
  
  // Manage Volunteer Schedule
  '管理志工班表': 'Manage Volunteer Schedule',
  '管理者模式：可不受時間限制調整所有志工的排班，但依然會照志工的可服勤時段有所限制': 'Manager Mode: Adjust all volunteer schedules without time restrictions, but still limited by volunteer availability',
  '志工姓名': 'Volunteer Name',
  '確定要儲存所有志工的排班嗎？': 'Are you sure to save all volunteer schedules?',
  '所有志工的排班已成功儲存': 'All volunteer schedules have been saved successfully',
  
  // Common
  '天': 'day(s)',
  '請移除': 'Please remove',
  '還需要選擇': 'Still need to select',
  '個人資訊': 'Personal Information',
  '請選擇出生年月日': 'Please select date of birth',
  '請選擇性別': 'Please select gender',
  '請輸入身份證字號': 'Please enter ID number',
  '請上傳照片': 'Please upload photo',
  '請輸入學校': 'Please enter school',
  '請輸入系所': 'Please enter department',
  '請選擇肄業/畢業': 'Please select study status',
  '請選擇婚姻狀況': 'Please select marital status',
  '請輸入戶籍地址': 'Please enter registered address',
  '請輸入通訊地址': 'Please enter mailing address',
  '請輸入就業單位': 'Please enter employer',
  '請輸入就讀學校': 'Please enter current school',
  '請說明其他狀態': 'Please describe other status',
  '請輸入語言名稱': 'Please enter language name',
  '請選擇語言程度': 'Please select language proficiency',
  '請選擇是否有特殊疾病': 'Please select whether you have special medical conditions',
  '確定送出': 'Confirm Submit',
  '休息日已達上限': 'Rest days limit reached',
  '例假日已達上限': 'Regular days off limit reached',
  '無法再新增': 'cannot add more',
  '的排班失敗': '\'s schedule save failed',
  '儲存失敗，請稍後再試': 'Save failed, please try again later',
  
  // Volunteer Application Additional
  '志工申請': 'Volunteer Application',
  '肄業/畢業': 'Status',
  '請選擇': 'Please select',
  '肄業': 'Enrolled',
  '畢業': 'Graduated',
  '婚姻狀況': 'Marital Status',
  '已婚': 'Married',
  '未婚': 'Single',
  '戶籍地址': 'Registered Address',
  '通訊地址': 'Mailing Address',
  '同戶籍地址': 'Same as registered address',
  '住家電話': 'Home Phone',
  '請輸入住家電話': 'Please enter home phone',
  '辦公電話': 'Office Phone',
  '請輸入辦公電話': 'Please enter office phone',
  '請輸入手機號碼': 'Please enter mobile number',
  '※ 住家電話、辦公電話、手機三者至少需填寫一個': '※ At least one of home phone, office phone, or mobile must be provided',
  '就業/就學狀況': 'Employment/Education Status',
  '就業/就學狀態': 'Employment/Education Status',
  '就業中': 'Employed',
  '就學中': 'Student',
  '退休': 'Retired',
  '就業單位': 'Employer',
  '就讀學校': 'Current School',
  '其他狀態說明': 'Other Status Description',
  '過去志工經驗': 'Past Volunteer Experience',
  '請描述過去的志工經驗': 'Please describe past volunteer experience',
  '目前志工經驗': 'Current Volunteer Experience',
  '請描述目前的志工經驗': 'Please describe current volunteer experience',
  '專長': 'Skills',
  '請說明其他專長': 'Please specify other skills',
  '興趣': 'Interests',
  '請描述您的興趣': 'Please describe your interests',
  '華語': 'Mandarin',
  '英語': 'English',
  '臺語': 'Taiwanese',
  '日語': 'Japanese',
  '精通': 'Fluent',
  '中等': 'Intermediate',
  '略懂': 'Basic',
  '不會': 'None',
  '其他語言': 'Other Languages',
  '有其他語言能力': 'Has other language skills',
  '語言名稱': 'Language Name',
  '特殊疾病': 'Special Medical Conditions',
  '請說明疾病狀況': 'Please describe medical condition',
  '星期/時間': 'Day/Time',
  '09時-12時': '09:00-12:00',
  '13時-16時': '13:00-16:00',
  '請依照優先順序勾選可服勤時段，系統會自動標注順序號碼': 'Please check available time slots in order of preference, the system will automatically number them',
  '自我介紹': 'Self Introduction',
  '請簡單介紹您自己': 'Please introduce yourself',
  '我已經詳細閱讀個人資料使用同意書並同意相關規範': 'I have read and agree to the Personal Data Usage Agreement',
  '下載個人資料使用同意書': 'Download Personal Data Usage Agreement',
  '返回首頁': 'Return to Home',
  '照片檔案大小不得超過 5MB': 'Photo file size must not exceed 5MB',
  '請選擇有效的圖片檔案 (JPG, PNG, GIF)': 'Please select a valid image file (JPG, PNG, GIF)',
  '請輸入有效的台灣身分證字號': 'Please enter a valid Taiwan ID number',
  '請上傳照片': 'Please upload photo',
  '請輸入學校': 'Please enter school',
  '請輸入系所': 'Please enter department',
  '請選擇肄業/畢業': 'Please select status',
  '住家電話、辦公電話、手機三者至少需填寫一個': 'At least one of home phone, office phone, or mobile must be provided',
  '請選擇就業/就學狀態': 'Please select employment/education status',
  '請選擇是否有志願服務手冊': 'Please select if you have volunteer service book',
  '請選擇華語能力': 'Please select Mandarin proficiency',
  '請選擇英語能力': 'Please select English proficiency',
  '請選擇臺語能力': 'Please select Taiwanese proficiency',
  '請選擇日語能力': 'Please select Japanese proficiency',
  '請至少選擇一個可服勤時段': 'Please select at least one available time slot',
  '請填寫自我介紹': 'Please write self introduction',
  '申請成功！我們將於審核後與您聯繫': 'Application successful! We will contact you after review',
  '申請失敗，請稍後再試': 'Application failed, please try again later',  '請輸入就業單位': 'Please enter your employer',
  '請輸入就讀學校': 'Please enter your school',
  '請輸入有效的手機號碼（格式：09XXXXXXXX）': 'Please enter a valid mobile number (format: 09XXXXXXXX)',
  '請選擇肄業/畢業': 'Please select status/graduation',
  '請輸入學校': 'Please enter school name',
  '請輸入系所': 'Please enter department',
  '請輸入有效的台灣身分證字號': 'Please enter a valid Taiwan ID number',
  '請上傳照片': 'Please upload photo',
  '請輸入電子信箱': 'Please enter email',
  '請輸入有效的電子信箱': 'Please enter a valid email',
  '請輸入姓名': 'Please enter name',
  '請選擇出生年月日': 'Please select date of birth',
  '請選擇性別': 'Please select gender',
  '請輸入身份證字號': 'Please enter ID number',
  '請選擇婚姻狀況': 'Please select marital status',
  '請輸入戶籍地址': 'Please enter registered address',
  '請輸入通訊地址': 'Please enter mailing address',
  '住家電話、辦公電話、手機三者至少需填寫一個': 'Please fill in at least one: home phone, office phone, or mobile',
  '請選擇就業/就學狀態': 'Please select employment/education status',
  '請說明其他狀態': 'Please specify other status',
  '請選擇是否有志願服務手冊': 'Please select if you have volunteer service record',
  '請選擇華語能力': 'Please select Mandarin proficiency',
  '請選擇英語能力': 'Please select English proficiency',
  '請輸入語言名稱': 'Please enter language name',
  '請選擇語言程度': 'Please select language level',
  '請選擇是否有特殊疾病': 'Please select if you have special medical conditions',
  '請說明疾病狀況': 'Please describe medical condition',
  '提交時發生錯誤，請稍後再試': 'An error occurred during submission, please try again later',
  '請閱讀並同意相關規範後再送出': 'Please read and agree to the terms before submitting',
  '志願服務手冊': 'Volunteer Service Record',
  '星期一': 'Monday',
  '星期二': 'Tuesday',
  '星期三': 'Wednesday',
  '星期四': 'Thursday',
  '星期五': 'Friday',
  '星期六': 'Saturday',
  '星期日': 'Sunday',
  '09時-12時': '09:00-12:00',
  '13時-16時': '13:00-16:00',
  '跳到中央內容區塊': 'Skip to main content',
  '姓名': 'Name',
}
